import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getBook } from '../utils/api/bookApi';
/**
 * Expands a classified with further details,
 * such as the book
 *
 * The conversation payload from ibok-server/ibok-mq ships the book's ISBN,
 * so the book is fetched from the Kotlin book endpoint by ISBN. The legacy
 * PHP book-by-id endpoint is no longer used.
 * */
var useClassifiedDetails = function (classified) {
    var _a = classified || {}, id = _a.id, bookIsbn = _a.bookIsbn, error = _a.error;
    var _b = useQuery(['books', 'isbn', bookIsbn], function () { return getBook(bookIsbn); }, {
        enabled: !!bookIsbn,
        staleTime: 1800000, // 30 minutes should be sufficient
    }), book = _b.data, isLoading = _b.isLoading;
    // Look up and display any potential errors the API
    // has injected to the sourcecode
    useEffect(function () {
        if (error) {
            console.error("Received a classified (id: " + id + ") with errors. Cannot retrieve more details", classified.error);
        }
        // eslint-disable-next-line
    }, [id, error]);
    return {
        isLoading: isLoading,
        classified: classified,
        book: book,
    };
};
export default useClassifiedDetails;
